import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { logoutUser, notifyAuthChanged } from "../../auth";
import EmployeeSidebar from "./EmployeeSidebar";
import "./Employees.css";

const EmployeePageShell = ({ active, title, text, children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logoutUser({ notify: false });
    navigate("/login", { replace: true });
    notifyAuthChanged();
  };

  useEffect(() => {
    document.body.classList.toggle("employee-sidebar-visible", sidebarOpen);
    return () => document.body.classList.remove("employee-sidebar-visible");
  }, [sidebarOpen]);

  useEffect(() => {
    document.body.classList.add("employee-dashboard-active");
    return () => document.body.classList.remove("employee-dashboard-active");
  }, []);

  return (
    <div className={`dashboard employee-dashboard-page ${sidebarOpen ? "user-sidebar-active" : ""}`}>
      <button type="button" className="employee-sidebar-toggle" onClick={() => setSidebarOpen(true)}>
        <span className="la la-bars"></span>
        Employer Menu
      </button>

      <div className="sidebar-backdrop" onClick={() => setSidebarOpen(false)}></div>
      <EmployeeSidebar active={active} onClose={() => setSidebarOpen(false)} />

      <section className="user-dashboard">
        <div className="dashboard-outer">
          <div className="upper-title-box employee-title-box">
            <div>
              <h3>{title}</h3>
              <div className="text">{text}</div>
            </div>
            <button type="button" className="employee-title-logout" onClick={handleLogout} aria-label="Logout">
              <span className="la la-sign-out"></span>
            </button>
          </div>
          {children}
        </div>
      </section>

      <div className="copyright-text">
        <p>Copyright 2026 Epic-Jobs. All Right Reserved.</p>
      </div>
    </div>
  );
};

export default EmployeePageShell;
